import React__default from 'react';
import PropTypes from 'prop-types';

var propTypes = {
  children: PropTypes.node.isRequired,
  /**
   * Invisible label of the group of toggle controls
   */
  ariaLabel: PropTypes.string,
  classList: PropTypes.string,
  /* Alias of ariaLabel: prefer to use ariaLabel instead */
  labelText: PropTypes.string,
  /**
   * The icon variant requires a different DOM so it has been disabled here.
   */
  variant: PropTypes.oneOf(['default', 'icon'])
};
function Toggle(_ref) {
  var ariaLabel = _ref.ariaLabel,
    children = _ref.children,
    _ref$classList = _ref.classList,
    classList = _ref$classList === void 0 ? '' : _ref$classList,
    labelText = _ref.labelText,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'default' : _ref$variant;
  return /*#__PURE__*/React__default.createElement("div", {
    "aria-label": ariaLabel || labelText,
    className: "toggle ".concat(classList),
    "data-variant": variant !== 'default' && variant ? variant : null,
    role: "radiogroup"
  }, children);
}
Toggle.propTypes = propTypes;

export { Toggle as default };
//# sourceMappingURL=Toggle.js.map
